module.exports = __webpack_public_path__ + "static/bishop-aboutus-logo-2f1cddb3f5b35b4622cb0ef11ce0e513.png";